import { CircularProgress, styled } from "@mui/material";

export const StyledLoader = styled(CircularProgress, {
  shouldForwardProp: (prop: string) => prop !== "isDisabled",
})<{ isDisabled?: boolean }>`
  color: ${({ isDisabled, theme }) =>
    theme.wsc.palette.neutral[isDisabled ? 300 : 0]};
`;
